






















import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    subtitle: 'Drag in files or folders.',
    dragover: false as boolean,
  }),

  methods: {
    handleDrop(e: any): void {
      // Change var and validate
      this.dragover = false
      if (!e || !e.dataTransfer || !e.dataTransfer.items) {
        return
      }

      // Uploading a folder will only return one item within the list
      // Need to use webkitGetAsEntry to iterate items and get all directory files
      // TODO: Add proper types to methods once they are supported
      let items: DataTransferItemList = e.dataTransfer.items
      const promises = []
      for (let i = 0; i < items.length; i++) {
        let item = items[i].webkitGetAsEntry()

        if (item) {
          promises.push(this.scanItem(item))
        }
      }
      Promise.all(promises).then(() => {
        this.$emit('finished')
      })
    },

    scanItem(item: any): Promise<boolean> {
      if (item.isDirectory) {
        return this.handleScanDirectory(item)
      } else {
        return this.addItemFileIfValid(item)
      }
    },

    handleScanDirectory(item: any): Promise<boolean> {
      // Iterate through items in directory and attempt to scan individually
      let directoryReader = item.createReader()
      const promises = [] as Promise<boolean>[]
      return this.processEntries(directoryReader, promises)
    },

    processEntries(
      directoryReader: any,
      promises: Promise<boolean>[]
    ): Promise<any> {
      return new Promise((resolve) => {
        directoryReader.readEntries((items: any) => {
          // check if done
          if (items.length === 0) {
            resolve(Promise.all(promises))
          }
          // Read this batch
          items.forEach((newItem: any) => {
            promises.push(this.scanItem(newItem))
          })
          // Read the next batch.
          resolve(this.processEntries(directoryReader, promises))
        })
      })
    },

    async addItemFileIfValid(item: any): Promise<boolean> {
      return new Promise((resolve, reject) => {
        try {
          this.getFileFromItem(item).then((file) => {
            if (!file) {
              this.$toast.show(`Skipping invalid file.`)
            } else {
              resolve(this.isValidFile(file))
            }
          })
        } catch (error) {
          reject(error.message)
        }
      })
    },

    // Underlying file retrieval uses callbacks. This function wraps it in a promise
    getFileFromItem(item: any): Promise<File | undefined> {
      return new Promise((resolve, reject) => item.file(resolve, reject))
    },

    isValidFile(file: File): Promise<boolean> {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = async (evt) => {
          if (evt.target?.readyState === FileReader.DONE) {
            let array = new Uint8Array(<ArrayBuffer>evt.target.result)
            if (this.isDICOMHeader(array)) {
              await this.$emit('addDICM', {
                buffer: <ArrayBuffer>evt.target.result,
                filename: file.name,
              })
              resolve(true)
            } else if (this.isPDFHeader(array)) {
              await this.$emit('addFile', {
                buffer: <ArrayBuffer>evt.target.result,
                filename: file.name,
                mime: 'application/pdf',
                description: '',
              })
              resolve(true)
            } else {
              await this.$emit('invalidFile', file.name)
              resolve(true)
            }
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    isPDFHeader(file: Uint8Array): boolean {
      let s = ''
      let start = 0,
        end = 5
      for (var i = start; i < end; ++i) {
        s += String.fromCharCode(file[i])
      }
      return s == '%PDF-'
    },
    isDICOMHeader(file: Uint8Array): boolean {
      let s = ''
      let start = 128,
        end = 132
      for (var i = start; i < end; ++i) {
        s += String.fromCharCode(file[i])
      }
      return s == 'DICM'
    },
  },
})
